export const FAVOURITES = 'FAVOURITES';
export const LAST_SEARCH = 'LAST_SEARCH';
export const THEMES = {
    LETGO: 'letgo',
    OLX: 'olx',
    OTOPLUS: 'otoplus',
    '321SPRZEDANE': '321sprzedane'
};

